import React from "react";
import { useParams } from "react-router-dom";
import BulkEditHeaderV2 from "./BulkEditHeaderV2";

const BulkEdit = () => {
  const { roasterId } = useParams();

  return <BulkEditHeaderV2 rosterId={roasterId} />;
};

export default BulkEdit;
